const options01 = [0, 1];
const options3 = [1, 2, 3];
const options12 = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
const options14 = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14];
const options16 = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16];
const options30 = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30];
const shipmentOptions = ['Upfront', 'Replacement']

export const genentechHubFieldTypes = {
    Num: 'num',                 //Any Number
    Num5: 'num5',               //Any Number up to 5 characters
    String50: 'string50',       //String up to 50 characters
    String150: 'string150',     //String up to 150 characters
    Num5x3: 'num5x3'            //3 dosages Up to 5 characters each
}

export const drugList = {
    Alecensa: 'Alecensa',
    Avastin: 'Avastin',
    Cotellic: 'Cotellic',
    Columvi: 'Columvi',
    Erivedge: 'Erivedge',
    Gavreto: 'Gavreto',
    Gazyva: 'Gazyva',
    Herceptin: 'Herceptin',
    HerceptinHylecta: 'Herceptin Hylecta',
    Kadcyla: 'Kadcyla',
    Lunsumio: 'Lunsumio',
    LunsumioVelo: 'LUNSUMIO VELO',
    Perjeta: 'Perjeta',
    Phesgo: 'Phesgo',
    Polivy: 'Polivy',
    Rituxan: 'Rituxan',
    RituxanHycela: 'Rituxan Hycela',
    Rozlytrek: 'Rozlytrek',
    Tecentriq: 'Tecentriq',
    Xeloda: 'Xeloda',
    Venclexta: 'Venclexta',
    Zelboraf: 'Zelboraf'
}

export const drugListDisplayNames = {
    [drugList.Alecensa]: 'ALECENSA® (alectinib)',
    [drugList.Avastin]: 'AVASTIN® (bevacizumab)',
    [drugList.Columvi]: 'COLUMVI (glofitamab-gxbm)',
    [drugList.Cotellic]: 'COTELLIC® (cobimetinib)',
    [drugList.Erivedge]: 'ERIVEDGE® (vismodegib)',
    [drugList.Gavreto]: 'GAVRETO® (pralsetinib)',
    [drugList.Gazyva]: 'GAZYVA® (obinutuzumab)',
    [drugList.Herceptin]: 'HERCEPTIN® (trastuzumab)',
    [drugList.HerceptinHylecta]: 'HERCEPTIN HYLECTA™ (trastuzumab and hyaluronidase-oysk)',
    [drugList.Kadcyla]: 'KADCYLA® (ado-trastuzumab emtansine)',
    [drugList.Lunsumio]: 'LUNSUMIO (mosunetuzumab-axgb)',
    [drugList.LunsumioVelo]: 'LUNSUMIO VELO (mosunetuzumab-axgb)',
    [drugList.Perjeta]: 'PERJETA® (pertuzumab)',
    [drugList.Phesgo]: 'PHESGO™  (pertuzumab, trastuzumab, and hyaluronidase-zzxf)',
    [drugList.Polivy]: 'POLIVY™ (polatuzumab vedotin-piiq)',
    [drugList.Rituxan]: 'RITUXAN® (rituximab)',
    [drugList.RituxanHycela]: 'RITUXAN HYCELA® (rituximab/hyaluronidase human)',
    [drugList.Rozlytrek]: 'ROZLYTREK™ (entrectinib)',
    [drugList.Tecentriq]: 'TECENTRIQ® (atezolizumab)',
    [drugList.Xeloda]: 'XELODA® (capecitabine)',
    [drugList.Venclexta]: 'VENCLEXTA® (venetoclax)',
    [drugList.Zelboraf]: 'ZELBORAF® (vemurafenib)'
}

export const genentechHubPharmacyDictionary = [
    {
        drugName: drugList.Alecensa,
        options: [
            {
                prescriptionType: null,
                prescriptionOption: '600 mg twice a day',
                numOfTablets: null,
                dosage: 600,
                dosageUnit: 'mg',
                dispenseQuantity: options3,
                dispenseUnitOptions: ['Month(s)'],
                frequencyOfAdministration: 'BID',
                sig: null,
                daysOff: null,
                numOfTabletsPerCycle: null,
                numOfCyclesPerFill: null,
                refills: options12
            },
            {
                prescriptionType: null,
                prescriptionOption: 'Other',
                numOfTablets: null,
                dosage: genentechHubFieldTypes.Num5, //Up to 5 characters
                dosageUnit: 'mg',
                dispenseQuantity: options3,
                dispenseUnitOptions: ['Month(s)'],
                frequencyOfAdministration: genentechHubFieldTypes.String50, //Up to 50 characters
                sig: null,
                daysOff: null,
                numOfTabletsPerCycle: null,
                numOfCyclesPerFill: null,
                refills: options12
            }
        ],
        addOnOptions: null,
        shipmentOptions: shipmentOptions
    },
    {
        drugName: drugList.Avastin,
        options: [
            {
                prescriptionType: null,
                prescriptionOption: 'Once every 2 weeks',
                numOfTablets: null,
                dosage: genentechHubFieldTypes.Num5, //Up to 5 characters
                dosageUnit: 'mg',
                dispenseQuantity: genentechHubFieldTypes.Num,
                dispenseUnitOptions: ['100 mg vial(s)', '400 mg vial(s)'],
                frequencyOfAdministration: 'Once every 2 weeks',
                sig: null,
                daysOff: null,
                numOfTabletsPerCycle: null,
                numOfCyclesPerFill: null,
                refills: options12
            },
            {
                prescriptionType: null,
                prescriptionOption: 'Other',
                numOfTablets: null,
                dosage: genentechHubFieldTypes.Num5, //Up to 5 characters
                dosageUnit: 'mg',
                dispenseQuantity: genentechHubFieldTypes.Num,
                dispenseUnitOptions: ['100 mg vial(s)', '400 mg vial(s)'],
                frequencyOfAdministration: genentechHubFieldTypes.String50, //Up to 50 characters
                sig: null,
                daysOff: null,
                numOfTabletsPerCycle: null,
                numOfCyclesPerFill: null,
                refills: options12
            }
        ],
        addOnOptions: [drugList.Tecentriq],
        shipmentOptions: shipmentOptions
    },
    {
        drugName: drugList.Columvi,
        options: [
            {
                prescriptionType: null,
                prescriptionOption: 'Ramp up',
                numOfTablets: null,
                dosage: null,
                dosageUnit: 'mg',
                dispenseQuantity: genentechHubFieldTypes.Num,
                dispenseUnitOptions: ['10 mg vial(s)', '2.5 mg vial(s)'],
                frequencyOfAdministration: null,
                sig: null,
                daysOff: null,
                numOfTabletsPerCycle: null,
                numOfCyclesPerFill: null,
                refills: options12
            },
            {
                prescriptionType: null,
                prescriptionOption: 'Other',
                numOfTablets: null,
                dosage: genentechHubFieldTypes.Num5, //Up to 5 characters
                dosageUnit: 'mg',
                dispenseQuantity: genentechHubFieldTypes.Num,
                dispenseUnitOptions: ['10 mg vial(s)', '2.5 mg vial(s)'],
                frequencyOfAdministration: genentechHubFieldTypes.String50, //Up to 50 characters
                sig: null,
                daysOff: null,
                numOfTabletsPerCycle: null,
                numOfCyclesPerFill: null,
                refills: options12
            }
        ],
        addOnOptions: null,
        shipmentOptions: shipmentOptions
    },
    {
        drugName: drugList.Cotellic,
        options: [
            {
                prescriptionType: null,
                prescriptionOption: '60 mg daily',
                numOfTablets: null,
                dosage: 60,
                dosageUnit: 'mg',
                dispenseQuantity: options3,
                dispenseUnitOptions: ['Month(s)'],
                frequencyOfAdministration: 'QD',
                sig: '60 mg Daily for 21 days on, followed by 7-day rest period.',
                daysOff: null,
                numOfTabletsPerCycle: null,
                numOfCyclesPerFill: null,
                refills: options12
            },
            {
                prescriptionType: null,
                prescriptionOption: 'Other',
                numOfTablets: null,
                dosage: genentechHubFieldTypes.Num5, //Up to 5 characters
                dosageUnit: 'mg',
                dispenseQuantity: options3,
                dispenseUnitOptions: ['Month(s)'],
                frequencyOfAdministration: genentechHubFieldTypes.String50, //Up to 50 characters
                sig: genentechHubFieldTypes.String50, //Up to 50 characters
                daysOff: null,
                numOfTabletsPerCycle: null,
                numOfCyclesPerFill: null,
                refills: options12
            }
        ],
        addOnOptions: [drugList.Zelboraf, drugList.Tecentriq],
        shipmentOptions: ['Upfront']
    },
    {
        drugName: drugList.Erivedge,
        options: [
            {
                prescriptionType: null,
                prescriptionOption: '150 mg daily',
                numOfTablets: null,
                dosage: 150,
                dosageUnit: 'mg',
                dispenseQuantity: options3,
                dispenseUnitOptions: ['Month(s)'],
                frequencyOfAdministration: 'QD',
                sig: null,
                daysOff: null,
                numOfTabletsPerCycle: null,
                numOfCyclesPerFill: null,
                refills: options12
            },
            {
                prescriptionType: null,
                prescriptionOption: 'Other',
                numOfTablets: null,
                dosage: genentechHubFieldTypes.Num5, //Up to 5 characters
                dosageUnit: 'mg',
                dispenseQuantity: genentechHubFieldTypes.Num,
                dispenseUnitOptions: ['Month(s)'],
                frequencyOfAdministration: genentechHubFieldTypes.String50, //Up to 50 characters
                sig: null,
                daysOff: null,
                numOfTabletsPerCycle: null,
                numOfCyclesPerFill: null,
                refills: options12
            }
        ],
        addOnOptions: null,
        shipmentOptions: shipmentOptions
    },
    {
        drugName: drugList.Gavreto,
        options: [
            {
                prescriptionType: null,
                prescriptionOption: '400 mg once daily',
                numOfTablets: null,
                dosage: 400,
                dosageUnit: 'mg',
                dispenseQuantity: options3,
                dispenseUnitOptions: ['Month(s)'],
                frequencyOfAdministration: 'once daily',
                sig: null,
                daysOff: null,
                numOfTabletsPerCycle: null,
                numOfCyclesPerFill: null,
                refills: options12
            },
            {
                prescriptionType: null,
                prescriptionOption: 'Other',
                numOfTablets: null,
                dosage: genentechHubFieldTypes.Num5, //Up to 5 characters
                dosageUnit: 'mg',
                dispenseQuantity: options3,
                dispenseUnitOptions: ['Month(s)'],
                frequencyOfAdministration: genentechHubFieldTypes.String50, //Up to 50 characters
                sig: null,
                daysOff: null,
                numOfTabletsPerCycle: null,
                numOfCyclesPerFill: null,
                refills: options12
            }
        ],
        addOnOptions: null,
        shipmentOptions: shipmentOptions
    },
    {
        drugName: drugList.Gazyva,
        options: [
            {
                prescriptionType: null,
                prescriptionOption: 'Day 1, Day 8 and Day 15',
                numOfTablets: null,
                dosage: genentechHubFieldTypes.Num5, //Up to 5 characters
                dosageUnit: 'mg',
                dispenseQuantity: genentechHubFieldTypes.Num,
                dispenseUnitOptions: ['1000 mg vial(s)'],
                frequencyOfAdministration: 'Day 1, Day 8 and Day 15',
                sig: null,
                daysOff: null,
                numOfTabletsPerCycle: null,
                numOfCyclesPerFill: null,
                refills: options12
            },
            {
                prescriptionType: null,
                prescriptionOption: 'Day 8 and Day 15',
                numOfTablets: null,
                dosage: genentechHubFieldTypes.Num5, //Up to 5 characters
                dosageUnit: 'mg',
                dispenseQuantity: genentechHubFieldTypes.Num,
                dispenseUnitOptions: ['1000 mg vial(s)'],
                frequencyOfAdministration: 'Day 8 and Day 15',
                sig: null,
                daysOff: null,
                numOfTabletsPerCycle: null,
                numOfCyclesPerFill: null,
                refills: options12
            },
            {
                prescriptionType: null,
                prescriptionOption: '100 mg on Day 1, and 900 mg on Day 2',
                numOfTablets: null,
                dosage: 1000,
                dosageUnit: 'mg',
                dispenseQuantity: genentechHubFieldTypes.Num,
                dispenseUnitOptions: ['1000 mg vial(s)'],
                frequencyOfAdministration: null,
                sig: '100 mg on Day 1, and 900 mg on Day 2',
                daysOff: null,
                numOfTabletsPerCycle: null,
                numOfCyclesPerFill: null,
                refills: options12
            },
            {
                prescriptionType: null,
                prescriptionOption: 'Other',
                numOfTablets: null,
                dosage: genentechHubFieldTypes.Num5, //Up to 5 characters
                dosageUnit: 'mg',
                dispenseQuantity: genentechHubFieldTypes.Num,
                dispenseUnitOptions: ['1000 mg vial(s)'],
                frequencyOfAdministration: genentechHubFieldTypes.String50, //Up to 50 characters
                sig: genentechHubFieldTypes.String50, //Up to 50 characters
                daysOff: null,
                numOfTabletsPerCycle: null,
                numOfCyclesPerFill: null,
                refills: options12
            }
        ],
        addOnOptions: [drugList.Venclexta],
        shipmentOptions: shipmentOptions
    },
    {
        drugName: drugList.Herceptin,
        options: [
            {
                prescriptionType: null,
                prescriptionOption: 'Once every 3 weeks',
                numOfTablets: null,
                dosage: 150,
                dosageUnit: 'mg',
                dispenseQuantity: genentechHubFieldTypes.Num,
                dispenseUnitOptions: ['150 mg vial(s)'],
                frequencyOfAdministration: 'Once every 3 weeks',
                sig: null,
                daysOff: null,
                numOfTabletsPerCycle: null,
                numOfCyclesPerFill: null,
                refills: options12
            },
            {
                prescriptionType: null,
                prescriptionOption: 'Other',
                numOfTablets: null,
                dosage: genentechHubFieldTypes.Num, //Up to 5 characters
                dosageUnit: 'mg',
                dispenseQuantity: genentechHubFieldTypes.Num,
                dispenseUnitOptions: ['150 mg vial(s)'],
                frequencyOfAdministration: genentechHubFieldTypes.String50, //Up to 50 characters
                sig: null,
                daysOff: null,
                numOfTabletsPerCycle: null,
                numOfCyclesPerFill: null,
                refills: options12
            }
        ],
        addOnOptions: [drugList.Perjeta],
        shipmentOptions: shipmentOptions
    },
    {
        drugName: drugList.HerceptinHylecta,
        options: [
            {
                prescriptionType: null,
                prescriptionOption: '600 mg trastuzumab/10,000 units hyaluronidase',
                numOfTablets: null,
                dosage: 600,
                dosageUnit: 'mg',
                dispenseQuantity: genentechHubFieldTypes.Num,
                dispenseUnitOptions: ['600 mg vial(s)'],
                frequencyOfAdministration: genentechHubFieldTypes.String50, //Up to 50 characters
                sig: null,
                daysOff: null,
                numOfTabletsPerCycle: null,
                numOfCyclesPerFill: null,
                refills: options12
            },
            {
                prescriptionType: null,
                prescriptionOption: 'Other',
                numOfTablets: null,
                dosage: genentechHubFieldTypes.Num5, //Up to 5 characters
                dosageUnit: 'mg',
                dispenseQuantity: genentechHubFieldTypes.Num,
                dispenseUnitOptions: ['600 mg vial(s)'],
                frequencyOfAdministration: genentechHubFieldTypes.String50, //Up to 50 characters
                sig: null,
                daysOff: null,
                numOfTabletsPerCycle: null,
                numOfCyclesPerFill: null,
                refills: options12
            }
        ],
        addOnOptions: null,
        shipmentOptions: shipmentOptions
    },
    {
        drugName: drugList.Kadcyla,
        options: [
            {
                prescriptionType: null,
                prescriptionOption: 'Once every 3 weeks',
                numOfTablets: null,
                dosage: genentechHubFieldTypes.Num5, //Up to 5 characters
                dosageUnit: 'mg',
                dispenseQuantity: genentechHubFieldTypes.Num,
                dispenseUnitOptions: ['100 mg vial(s)', '160 mg vial(s)'],
                frequencyOfAdministration: 'Once every 3 weeks',
                sig: null,
                daysOff: null,
                numOfTabletsPerCycle: null,
                numOfCyclesPerFill: null,
                refills: options12
            },
            {
                prescriptionType: null,
                prescriptionOption: 'Other',
                numOfTablets: null,
                dosage: genentechHubFieldTypes.Num5, //Up to 5 characters
                dosageUnit: 'mg',
                dispenseQuantity: genentechHubFieldTypes.Num,
                dispenseUnitOptions: ['100 mg vial(s)', '160 mg vial(s)'],
                frequencyOfAdministration: genentechHubFieldTypes.String50, //Up to 50 characters
                sig: null,
                daysOff: null,
                numOfTabletsPerCycle: null,
                numOfCyclesPerFill: null,
                refills: options12
            }
        ],
        addOnOptions: null,
        shipmentOptions: shipmentOptions
    },
    {
        drugName: drugList.Perjeta,
        options: [
            {
                prescriptionType: null,
                prescriptionOption: '840 mg as Initial Dose',
                numOfTablets: null,
                dosage: 840,
                dosageUnit: 'mg',
                dispenseQuantity: genentechHubFieldTypes.Num,
                dispenseUnitOptions: ['420 mg vial(s)'],
                frequencyOfAdministration: 'Once',
                sig: null,
                daysOff: null,
                numOfTabletsPerCycle: null,
                numOfCyclesPerFill: null,
                refills: [0]
            },
            {
                prescriptionType: null,
                prescriptionOption: 'Once every 3 weeks',
                numOfTablets: null,
                dosage: genentechHubFieldTypes.Num5, //Up to 5 characters
                dosageUnit: 'mg',
                dispenseQuantity: genentechHubFieldTypes.Num,
                dispenseUnitOptions: ['420 mg vial(s)'],
                frequencyOfAdministration: 'Once every 3 weeks',
                sig: null,
                daysOff: null,
                numOfTabletsPerCycle: null,
                numOfCyclesPerFill: null,
                refills: options12
            },
            {
                prescriptionType: null,
                prescriptionOption: 'Other',
                numOfTablets: null,
                dosage: genentechHubFieldTypes.Num5, //Up to 5 characters
                dosageUnit: 'mg',
                dispenseQuantity: genentechHubFieldTypes.Num,
                dispenseUnitOptions: ['420 mg vial(s)'],
                frequencyOfAdministration: genentechHubFieldTypes.String50, //Up to 50 characters
                sig: null,
                daysOff: null,
                numOfTabletsPerCycle: null,
                numOfCyclesPerFill: null,
                refills: options12
            }
        ],
        addOnOptions: [drugList.Herceptin],
        shipmentOptions: shipmentOptions
    },
    {
        drugName: drugList.Phesgo,
        options: [
            {
                prescriptionType: null,
                prescriptionOption: '1200 mg pertuzumab, 600 mg trastuzumab and 30,000 units hyaluronidase',
                numOfTablets: null,
                dosage: 1200,
                dosageUnit: 'mg',
                dispenseQuantity: genentechHubFieldTypes.Num,
                dispenseUnitOptions: ['1200mg', '1800mg'],
                frequencyOfAdministration: genentechHubFieldTypes.String50, //Up to 50 characters
                sig: null,
                daysOff: null,
                numOfTabletsPerCycle: null,
                numOfCyclesPerFill: null,
                refills: options12
            },
            {
                prescriptionType: null,
                prescriptionOption: '600 mg pertuzumab, 600 mg trastuzumab and 20,000 units hyaluronidase',
                numOfTablets: null,
                dosage: 600,
                dosageUnit: 'mg',
                dispenseQuantity: genentechHubFieldTypes.Num,
                dispenseUnitOptions: ['1200mg', '1800mg'],
                frequencyOfAdministration: genentechHubFieldTypes.String50, //Up to 50 characters
                sig: null,
                daysOff: null,
                numOfTabletsPerCycle: null,
                numOfCyclesPerFill: null,
                refills: options12
            },
            {
                prescriptionType: null,
                prescriptionOption: 'Other',
                numOfTablets: null,
                dosage: genentechHubFieldTypes.Num5, //Up to 5 characters
                dosageUnit: 'mg',
                dispenseQuantity: genentechHubFieldTypes.Num,
                dispenseUnitOptions: ['1200mg', '1800mg'],
                frequencyOfAdministration: genentechHubFieldTypes.String50, //Up to 50 characters
                sig: null,
                daysOff: null,
                numOfTabletsPerCycle: null,
                numOfCyclesPerFill: null,
                refills: options12
            }
        ],
        addOnOptions: null,
        shipmentOptions: shipmentOptions
    },
    {
        drugName: drugList.Polivy,
        options: [
            {
                prescriptionType: null,
                prescriptionOption: 'Once every 21 Days',
                numOfTablets: null,
                dosage: genentechHubFieldTypes.Num5, //Up to 5 characters
                dosageUnit: 'mg',
                dispenseQuantity: genentechHubFieldTypes.Num,
                dispenseUnitOptions: ['30 mg vial(s)', '140 mg vial(s)'],
                frequencyOfAdministration: 'Once every 21 Days',
                sig: null,
                daysOff: null,
                numOfTabletsPerCycle: null,
                numOfCyclesPerFill: null,
                refills: options12
            },
            {
                prescriptionType: null,
                prescriptionOption: 'Other',
                numOfTablets: null,
                dosage: genentechHubFieldTypes.Num5, //Up to 5 characters
                dosageUnit: 'mg',
                dispenseQuantity: genentechHubFieldTypes.Num,
                dispenseUnitOptions: ['30 mg vial(s)', '140 mg vial(s)'],
                frequencyOfAdministration: genentechHubFieldTypes.String50, //Up to 50 characters
                sig: null,
                daysOff: null,
                numOfTabletsPerCycle: null,
                numOfCyclesPerFill: null,
                refills: options12
            }
        ],
        addOnOptions: [drugList.Rituxan],
        shipmentOptions: shipmentOptions
    },
    {
        drugName: drugList.Rituxan,
        options: [
            {
                prescriptionType: null,
                prescriptionOption: 'Once a Week for 3 weeks',
                numOfTablets: null,
                dosage: null,
                dosageUnit: 'mg',
                dispenseQuantity: genentechHubFieldTypes.Num,
                dispenseUnitOptions: ['100 mg vial(s)', '500 mg vial(s)'],
                frequencyOfAdministration: 'Once a week',
                sig: null,
                daysOff: null,
                numOfTabletsPerCycle: null,
                numOfCyclesPerFill: null,
                refills: options12
            },
            {
                prescriptionType: null,
                prescriptionOption: 'Other',
                numOfTablets: null,
                dosage: genentechHubFieldTypes.Num5, //Up to 5 characters
                dosageUnit: 'mg',
                dispenseQuantity: genentechHubFieldTypes.Num,
                dispenseUnitOptions: ['100 mg vial(s)', '500 mg vial(s)'],
                frequencyOfAdministration: genentechHubFieldTypes.String50, //Up to 50 characters
                sig: null,
                daysOff: null,
                numOfTabletsPerCycle: null,
                numOfCyclesPerFill: null,
                refills: options12
            }
        ],
        addOnOptions: [drugList.Venclexta, drugList.RituxanHycela, drugList.Polivy],
        shipmentOptions: shipmentOptions
    },
    {
        drugName: drugList.RituxanHycela,
        options: [
            {
                prescriptionType: null,
                prescriptionOption: 'Every 2 Months',
                numOfTablets: null,
                dosage: genentechHubFieldTypes.Num5, //Up to 5 characters
                dosageUnit: 'mg',
                dispenseQuantity: genentechHubFieldTypes.Num,
                dispenseUnitOptions: ['1400 mg vial(s)', '1600 mg vial(s)'],
                frequencyOfAdministration: 'Every 2 Months',
                sig: null,
                daysOff: null,
                numOfTabletsPerCycle: null,
                numOfCyclesPerFill: null,
                refills: options12
            },
            {
                prescriptionType: null,
                prescriptionOption: 'Every 21 Days',
                numOfTablets: null,
                dosage: genentechHubFieldTypes.Num5, //Up to 5 characters
                dosageUnit: 'mg',
                dispenseQuantity: genentechHubFieldTypes.Num,
                dispenseUnitOptions: ['1400 mg vial(s)', '1600 mg vial(s)'],
                frequencyOfAdministration: 'Every 21 Days',
                sig: null,
                daysOff: null,
                numOfTabletsPerCycle: null,
                numOfCyclesPerFill: null,
                refills: options12
            },
            {
                prescriptionType: null,
                prescriptionOption: 'Every 28 Days',
                numOfTablets: null,
                dosage: genentechHubFieldTypes.Num5, //Up to 5 characters
                dosageUnit: 'mg',
                dispenseQuantity: genentechHubFieldTypes.Num,
                dispenseUnitOptions: ['1400 mg vial(s)', '1600 mg vial(s)'],
                frequencyOfAdministration: 'Every 28 Days',
                sig: null,
                daysOff: null,
                numOfTabletsPerCycle: null,
                numOfCyclesPerFill: null,
                refills: options12
            },
            {
                prescriptionType: null,
                prescriptionOption: 'Other',
                numOfTablets: null,
                dosage: genentechHubFieldTypes.Num5, //Up to 5 characters
                dosageUnit: 'mg',
                dispenseQuantity: genentechHubFieldTypes.Num,
                dispenseUnitOptions: ['1400 mg vial(s)', '1600 mg vial(s)'],
                frequencyOfAdministration: genentechHubFieldTypes.String50, //Up to 50 characters
                sig: null,
                daysOff: null,
                numOfTabletsPerCycle: null,
                numOfCyclesPerFill: null,
                refills: options12
            },
            {
                prescriptionType: null,
                prescriptionOption: 'Weekly',
                numOfTablets: null,
                dosage: genentechHubFieldTypes.Num5, //Up to 5 characters
                dosageUnit: 'mg',
                dispenseQuantity: genentechHubFieldTypes.Num,
                dispenseUnitOptions: ['1400 mg vial(s)', '1600 mg vial(s)'],
                frequencyOfAdministration: 'Weekly',
                sig: null,
                daysOff: null,
                numOfTabletsPerCycle: null,
                numOfCyclesPerFill: null,
                refills: options12
            }
        ],
        addOnOptions: [drugList.Rituxan],
        shipmentOptions: shipmentOptions
    },
    {
        drugName: drugList.Rozlytrek,
        options: [
            {
                prescriptionType: null,
                prescriptionOption: '600 mg once daily',
                numOfTablets: null,
                dosage: 600,
                dosageUnit: 'mg',
                dispenseQuantity: options3,
                dispenseUnitOptions: ['Month(s)'],
                frequencyOfAdministration: 'QD',
                sig: null,
                daysOff: null,
                numOfTabletsPerCycle: null,
                numOfCyclesPerFill: null,
                refills: options12
            },
            {
                prescriptionType: null,
                prescriptionOption: 'Other',
                numOfTablets: null,
                dosage: genentechHubFieldTypes.Num5, //Up to 5 characters
                dosageUnit: 'mg',
                dispenseQuantity: genentechHubFieldTypes.Num5,
                dispenseUnitOptions: ['Month(s)'],
                frequencyOfAdministration: genentechHubFieldTypes.String50, //Up to 50 characters
                sig: null,
                daysOff: null,
                numOfTabletsPerCycle: null,
                numOfCyclesPerFill: null,
                refills: options12
            }
        ],
        addOnOptions: null,
        shipmentOptions: ['Upfront']
    },
    {
        drugName: drugList.Tecentriq,
        options: [
            {
                prescriptionType: null,
                prescriptionOption: 'Once every 3 weeks',
                numOfTablets: null,
                dosage: genentechHubFieldTypes.Num5, //Up to 5 characters
                dosageUnit: 'mg',
                dispenseQuantity: genentechHubFieldTypes.Num,
                dispenseUnitOptions: ['840 mg vial(s)', '1200 mg vial(s)'],
                frequencyOfAdministration: 'Once every 3 weeks',
                sig: null,
                daysOff: null,
                numOfTabletsPerCycle: null,
                numOfCyclesPerFill: null,
                refills: options12
            },
            {
                prescriptionType: null,
                prescriptionOption: 'Other',
                numOfTablets: null,
                dosage: genentechHubFieldTypes.Num5, //Up to 5 characters
                dosageUnit: 'mg',
                dispenseQuantity: genentechHubFieldTypes.Num,
                dispenseUnitOptions: ['840 mg vial(s)', '1200 mg vial(s)'],
                frequencyOfAdministration: genentechHubFieldTypes.String50, //Up to 50 characters
                sig: null,
                daysOff: null,
                numOfTabletsPerCycle: null,
                numOfCyclesPerFill: null,
                refills: options12
            }
        ],
        addOnOptions: [drugList.Avastin, drugList.Cotellic, drugList.Zelboraf],
        shipmentOptions: shipmentOptions
    },
    {
        drugName: drugList.Xeloda,
        options: [
            {
                prescriptionType: 'Standard',
                prescriptionOption: '150 mg',
                numOfTablets: genentechHubFieldTypes.Num5, //Up to 5 characters
                dosage: 150,
                dosageUnit: 'mg',
                dispenseQuantity: options30,
                dispenseUnitOptions: ['Days'],
                frequencyOfAdministration: [1, 2, 3, 4, 5],
                sig: null,
                daysOff: options30,
                numOfTabletsPerCycle: genentechHubFieldTypes.Num5, //Up to 5 characters
                numOfCyclesPerFill: options12,
                refills: options12
            },
            {
                prescriptionType: 'Standard',
                prescriptionOption: '500 mg',
                numOfTablets: genentechHubFieldTypes.Num5, //Up to 5 characters
                dosage: 500,
                dosageUnit: 'mg',
                dispenseQuantity: options30,
                dispenseUnitOptions: ['Days'],
                frequencyOfAdministration: [1, 2, 3, 4, 5],
                sig: null,
                daysOff: options30,
                numOfTabletsPerCycle: genentechHubFieldTypes.Num5, //Up to 5 characters
                numOfCyclesPerFill: options12,
                refills: options12
            },
            {
                prescriptionType: 'Other',
                prescriptionOption: '150 mg',
                numOfTablets: null,
                dosage: 150,
                dosageUnit: 'mg',
                dispenseQuantity: null,
                dispenseUnitOptions: null,
                frequencyOfAdministration: null,
                sig: genentechHubFieldTypes.String150, //Up to 150 characters
                daysOff: null,
                numOfTabletsPerCycle: genentechHubFieldTypes.Num5, //Up to 5 characters
                numOfCyclesPerFill: options12,
                refills: options12
            },
            {
                prescriptionType: 'Other',
                prescriptionOption: '500 mg',
                numOfTablets: null,
                dosage: 500,
                dosageUnit: 'mg',
                dispenseQuantity: null,
                dispenseUnitOptions: null,
                frequencyOfAdministration: null,
                sig: genentechHubFieldTypes.String150, //Up to 150 characters
                daysOff: null,
                numOfTabletsPerCycle: genentechHubFieldTypes.Num5, //Up to 5 characters
                numOfCyclesPerFill: options12,
                refills: options12
            }
        ],
        addOnOptions: null,
        shipmentOptions: ['Upfront']
    },
    {
        drugName: drugList.Venclexta,
        options: [
            {
                prescriptionType: 'CLL/SLL (Maint)',
                prescriptionOption: 'Maintenance',
                numOfTablets: null,
                dosage: genentechHubFieldTypes.Num5, //Up to 5 characters
                dosageUnit: 'mg',
                dispenseQuantity: 1,
                dispenseUnitOptions: ['Month(s)'],
                frequencyOfAdministration: 'Daily',
                sig: null,
                daysOff: null,
                numOfTabletsPerCycle: null,
                numOfCyclesPerFill: null,
                refills: options01
            },
            {
                prescriptionType: 'AML (Maint)',
                prescriptionOption: 'Maintenance',
                numOfTablets: null,
                dosage: genentechHubFieldTypes.Num5, //Up to 5 characters
                dosageUnit: 'mg',
                dispenseQuantity: 1,
                dispenseUnitOptions: ['Month(s)'],
                frequencyOfAdministration: 'Daily',
                sig: null,
                daysOff: null,
                numOfTabletsPerCycle: null,
                numOfCyclesPerFill: null,
                refills: options01
            },
            {
                prescriptionType: 'Other Dosing (Maint)',
                prescriptionOption: 'Maintenance',
                numOfTablets: null,
                dosage: genentechHubFieldTypes.Num5, //Up to 5 characters
                dosageUnit: 'mg',
                dispenseQuantity: 1,
                dispenseUnitOptions: ['Month(s)'],
                frequencyOfAdministration: 'Daily',
                sig: null,
                daysOff: null,
                numOfTabletsPerCycle: null,
                numOfCyclesPerFill: null,
                refills: options01
            },
            {
                prescriptionType: 'AML (Ramp-up)',
                prescriptionOption: 'Ramp-up Dosing',
                numOfTablets: null,
                dosage: genentechHubFieldTypes.Num5x3, //3 dosages Up to 5 characters each
                dosageUnit: 'mg',
                dispenseQuantity: 3,
                dispenseUnitOptions: ['Day(s)'],
                frequencyOfAdministration: 'Daily',
                sig: null,
                daysOff: null,
                numOfTabletsPerCycle: null,
                numOfCyclesPerFill: null,
                refills: [0]
            },
            {
                prescriptionType: 'Other Dosing (Ramp-up)',
                prescriptionOption: 'Ramp-up Dosing',
                numOfTablets: null,
                dosage: genentechHubFieldTypes.Num5, //Up to 5 characters
                dosageUnit: 'mg',
                dispenseQuantity: 1,
                dispenseUnitOptions: ['Month(s)'],
                frequencyOfAdministration: null,
                sig: genentechHubFieldTypes.String150, //Up to 150 characters
                daysOff: null,
                numOfTabletsPerCycle: null,
                numOfCyclesPerFill: null,
                refills: options01
            },
            {
                prescriptionType: 'CLL/SLL (Start)',
                prescriptionOption: 'Starting Pack',
                numOfTablets: null,
                dosage: null,
                dosageUnit: null,
                dispenseQuantity: 1,
                dispenseUnitOptions: ['Month(s)'],
                frequencyOfAdministration: null,
                sig: null,
                daysOff: null,
                numOfTabletsPerCycle: null,
                numOfCyclesPerFill: null,
                refills: [0]
            }
        ],
        addOnOptions: [drugList.Gazyva, drugList.Rituxan],
        shipmentOptions: ['Upfront']
    },
    {
        drugName: drugList.Zelboraf,
        options: [
            {
                prescriptionType: null,
                prescriptionOption: '960 mg Twice a day',
                numOfTablets: null,
                dosage: 960,
                dosageUnit: 'mg',
                dispenseQuantity: options3,
                dispenseUnitOptions: ['Month(s)'],
                frequencyOfAdministration: 'BID',
                sig: null,
                daysOff: null,
                numOfTabletsPerCycle: null,
                numOfCyclesPerFill: null,
                refills: options12
            },
            {
                prescriptionType: null,
                prescriptionOption: '960 mg twice daily for 21, 720 mg twice daily thereafter',
                numOfTablets: null,
                dosage: 960,
                dosageUnit: 'mg',
                dispenseQuantity: options3,
                dispenseUnitOptions: ['Month(s)'],
                frequencyOfAdministration: 'BID',
                sig: null,
                daysOff: null,
                numOfTabletsPerCycle: null,
                numOfCyclesPerFill: null,
                refills: options12
            },
            {
                prescriptionType: null,
                prescriptionOption: 'Other',
                numOfTablets: null,
                dosage: genentechHubFieldTypes.Num5, //Up to 5 characters
                dosageUnit: 'mg',
                dispenseQuantity: options3,
                dispenseUnitOptions: ['Month(s)'],
                frequencyOfAdministration: genentechHubFieldTypes.String50, //Up to 50 characters
                sig: null,
                daysOff: null,
                numOfTabletsPerCycle: null,
                numOfCyclesPerFill: null,
                refills: options12
            }
        ],
        addOnOptions: [drugList.Cotellic, drugList.Tecentriq],
        shipmentOptions: ['Upfront']
    },
    {
        drugName: drugList.Lunsumio,
        options: [
            {
                prescriptionType: 'Cycle',
                prescriptionOption: 'Cycle 1: Step-up Dosing',
                numOfTablets: null,
                dosage: null,
                dosageUnit: null,
                dispenseQuantity: genentechHubFieldTypes.Num,
                dispenseUnitOptions: ['1 mg vial(s)', '30 mg vial(s)'],
                frequencyOfAdministration: null,
                sig: "Day 1 - Titrate 1 mg / Day 8 - Titrate 2 mg / Day 15 - Titrate 60 mg",
                daysOff: null,
                numOfTabletsPerCycle: null,
                numOfCyclesPerFill: null,
                refills: null
            },
            {
                prescriptionType: 'Cycle',
                prescriptionOption: 'Cycle 2',
                numOfTablets: null,
                dosage: '60',
                dosageUnit: 'mg',
                dispenseQuantity: genentechHubFieldTypes.Num,
                dispenseUnitOptions: ['1 mg vial(s)', '30 mg vial(s)'],
                frequencyOfAdministration: null,
                sig: "60 mg once on Day 1 of Cycle 2",
                daysOff: null,
                numOfTabletsPerCycle: null,
                numOfCyclesPerFill: null,
                refills: null
            },
            {
                prescriptionType: 'Cycle',
                prescriptionOption: 'Cycles 3 - 17',
                numOfTablets: null,
                dosage: '30',
                dosageUnit: 'mg',
                dispenseQuantity: genentechHubFieldTypes.Num,
                dispenseUnitOptions: ['1 mg vial(s)', '30 mg vial(s)'],
                frequencyOfAdministration: null,
                sig: "once every 21 days, up to 14 cycles",
                daysOff: null,
                numOfTabletsPerCycle: null,
                numOfCyclesPerFill: null,
                refills: options14
            },
            {
                prescriptionType: 'Other',
                prescriptionOption: 'Other - 1 mg vial(s)',
                numOfTablets: null,
                dosage: genentechHubFieldTypes.Num5,
                dosageUnit: 'mg',
                dispenseQuantity: genentechHubFieldTypes.Num,
                dispenseUnitOptions: ['1 mg vial(s)', '30 mg vial(s)'],
                frequencyOfAdministration: genentechHubFieldTypes.String50,
                sig: null,
                daysOff: null,
                numOfTabletsPerCycle: null,
                numOfCyclesPerFill: null,
                refills: options16
            },
            {
                prescriptionType: 'Other',
                prescriptionOption: 'Other - 30 mg vial(s)',
                numOfTablets: null,
                dosage: genentechHubFieldTypes.Num5,
                dosageUnit: 'mg',
                dispenseQuantity: genentechHubFieldTypes.Num,
                dispenseUnitOptions: ['1 mg vial(s)', '30 mg vial(s)'],
                frequencyOfAdministration: genentechHubFieldTypes.String50,
                sig: null,
                daysOff: null,
                numOfTabletsPerCycle: null,
                numOfCyclesPerFill: null,
                refills: options16
            }
        ],
        addOnOptions: null,
        shipmentOptions: shipmentOptions
    },
    {
        drugName: drugList.LunsumioVelo,
        options: [
            {
                prescriptionType: 'Cycle',
                prescriptionOption: 'Cycle 1: Step-up Dosing',
                numOfTablets: null,
                dosage: null,
                dosageUnit: null,
                dispenseQuantity: genentechHubFieldTypes.Num,
                dispenseUnitOptions: ['45 mg vial(s)', '5 mg vial(s)'],
                frequencyOfAdministration: null,
                sig: null,
                daysOff: null,
                numOfTabletsPerCycle: null,
                numOfCyclesPerFill: null,
                refills: null
            },
            {
                prescriptionType: 'Cycle',
                prescriptionOption: 'Cycle 2 - 17',
                numOfTablets: null,
                dosage: '45',
                dosageUnit: 'mg',
                dispenseQuantity: genentechHubFieldTypes.Num,
                dispenseUnitOptions: ['45 mg vial(s)', '5 mg vial(s)'],
                frequencyOfAdministration: null,
                sig: 'once every 21 days, up to 15 cycles',
                daysOff: null,
                numOfTabletsPerCycle: null,
                numOfCyclesPerFill: null,
                refills: null
            },
            {
                prescriptionType: 'Dose Reduction',
                prescriptionOption: 'Dose Reduction - 5 mg vial(s)',
                numOfTablets: null,
                dosage: genentechHubFieldTypes.Num5,
                dosageUnit: 'mg',
                dispenseQuantity: genentechHubFieldTypes.Num,
                dispenseUnitOptions: ['45 mg vial(s)', '5 mg vial(s)'],
                frequencyOfAdministration: genentechHubFieldTypes.String50,
                sig: null,
                daysOff: null,
                numOfTabletsPerCycle: null,
                numOfCyclesPerFill: null,
                refills: options16
            }
        ],
        addOnOptions: null,
        shipmentOptions: shipmentOptions
    },
]